import React, { useState, useEffect } from "react";
import { useSelector } from 'react-redux';
import {
  Collapse,
  Button as ReactstrapButton,
  FormGroup,
  Label,
  Input
} from "reactstrap";

import {
  IconButton,
  Button,
  Grid,
  Typography,
  Box
} from "@material-ui/core";

import { ExpandLess, ExpandMore } from "@material-ui/icons";
import { translator } from "../../utils/Translator";

import TextInput from "../FormElements/TextInput";
import SelectInput from "components/FormElements/SelectInput";
import axios from "axios";

const ProductSelectorFilter = ({ onFilterChange, isDisabled = false, docType }) => {

  const { authUser } = useSelector(({ auth }) => auth);
  const { translate } = useSelector(({ i18n }) => i18n);
  const { languageSelected } = useSelector(({ settings }) => settings);

  const [open, setOpen] = useState(false); // เปลี่ยนเป็น false เพื่อให้ปิด filter ไว้ตอนเริ่มต้น
  const [selectedTab, setSelectedTab] = useState("all");
  const [keyword, setKeyword] = useState("");

  // ตัวเลือกกลุ่มสินค้า
  const [productItemGroupList, setProductItemGroupList] = useState([]);
  const [selectedProductItemGroup, setSelectedProductItemGroup] = useState(null);

  // ตัวเลือกหมวดสินค้า
  const [productGroupList, setProductGroupList] = useState([]);
  const [selectedProductGroup, setSelectedProductGroup] = useState(null);

  // ตัวเลือกLineสินค้า
  const [productLineList, setProductLineList] = useState([]);
  const [selectedProductLine, setSelectedProductLine] = useState(null);

  // ตัวเลือกประเภทสินค้า
  const [productTypeList, setProductTypeList] = useState([]);
  const [selectedProductType, setSelectedProductType] = useState(null);

  // ตัวเลือกกิจกรรมการตลาด
  const [marketingEventList, setMarketingEventList] = useState([]);
  const [selectedMarketingEvent, setSelectedMarketingEvent] = useState(null);

  // ตัวเลือกสินค้าร่วมรายการ
  const [productPromotionList, setProductPromotionList] = useState([]);
  const [selectedProductPromotion, setSelectedProductPromotion] = useState(null);

  // ตัวเลือกประเภทสินค้า VAT
  const [vatTypeList, setVatTypeList] = useState([]);
  const [selectedVatType, setSelectedVatType] = useState(null);

  // สร้าง query params สำหรับ filter
  const buildFilterParams = () => {
    const params = {
      company: authUser.company !== "#" ? authUser.company : "",
      language: languageSelected?.id || 1,
      itemGroup: selectedProductItemGroup?.value || "",
      productGroup: selectedProductGroup?.value || "",
      productLine: selectedProductLine?.value || "",
      productType: selectedProductType?.value || "",
      mktEventCode: selectedMarketingEvent?.value || "",
      productSetCode: selectedProductPromotion?.value || "",
    };

    return params;
  };

  // API Calls
  const fetchProductItemGroup = async () => {
    try {
      const params = buildFilterParams();
      const url = `${process.env.REACT_APP_API_URL}productFilter/item-group`;
      const config = {
        params,
        headers: {
          Authorization: `Bearer ${localStorage.getItem('x-access-token')}`,
        },
      };

      const response = await axios.get(url, config);
      const data = response.data.data || response.data;

      // แปลง format เป็น value, label
      const formattedData = data.map((item) => ({
        value: item.ItemGroupCode,
        label: item.ItemGroupDescription,
      }));

      setProductItemGroupList(formattedData);
    } catch (error) {
      console.error("Error fetching product item group:", error);
      setProductItemGroupList([]);
    }
  };

  const fetchProductGroup = async () => {
    try {
      const params = buildFilterParams();
      const url = `${process.env.REACT_APP_API_URL}productFilter/product-group`;
      const config = {
        params,
        headers: {
          Authorization: `Bearer ${localStorage.getItem('x-access-token')}`,
        },
      };

      const response = await axios.get(url, config);
      const data = response.data.data || response.data;

      const formattedData = data.map((item) => ({
        value: item.ProductGroup,
        label: item.ProductGroup,
      }));

      setProductGroupList(formattedData);
    } catch (error) {
      console.error("Error fetching product group:", error);
      setProductGroupList([]);
    }
  };

  const fetchProductLine = async () => {
    try {
      const params = buildFilterParams();
      const url = `${process.env.REACT_APP_API_URL}productFilter/product-line`;
      const config = {
        params,
        headers: {
          Authorization: `Bearer ${localStorage.getItem('x-access-token')}`,
        },
      };

      const response = await axios.get(url, config);
      const data = response.data.data || response.data;

      const formattedData = data.map((item) => ({
        value: item.ProductLine,
        label: item.ProductLine,
      }));

      setProductLineList(formattedData);
    } catch (error) {
      console.error("Error fetching product line:", error);
      setProductLineList([]);
    }
  };

  const fetchProductType = async () => {
    try {
      const params = buildFilterParams();
      const url = `${process.env.REACT_APP_API_URL}productFilter/product-type`;
      const config = {
        params,
        headers: {
          Authorization: `Bearer ${localStorage.getItem('x-access-token')}`,
        },
      };

      const response = await axios.get(url, config);
      const data = response.data.data || response.data;

      const formattedData = data.map((item) => ({
        value: item.ProductType,
        label: item.ProductType,
      }));

      setProductTypeList(formattedData);
    } catch (error) {
      console.error("Error fetching product type:", error);
      setProductTypeList([]);
    }
  };

  const fetchMarketingEvent = async () => {
    try {
      const params = buildFilterParams();
      const url = `${process.env.REACT_APP_API_URL}productFilter/marketing-event`;
      const config = {
        params,
        headers: {
          Authorization: `Bearer ${localStorage.getItem('x-access-token')}`,
        },
      };

      const response = await axios.get(url, config);
      const data = response.data.data || response.data;

      const formattedData = data.map((item) => ({
        value: item.MktEventCode,
        label: item.MktEventDescription,
      }));

      setMarketingEventList(formattedData);
    } catch (error) {
      console.error("Error fetching marketing event:", error);
      setMarketingEventList([]);
    }
  };

  const fetchProductPromotion = async () => {
    try {
      const params = buildFilterParams();
      const url = `${process.env.REACT_APP_API_URL}productFilter/product-set`;
      const config = {
        params,
        headers: {
          Authorization: `Bearer ${localStorage.getItem('x-access-token')}`,
        },
      };

      const response = await axios.get(url, config);
      const data = response.data.data || response.data;

      const formattedData = data.map((item) => ({
        value: item.ProductSetCode,
        label: item.ProductSetDescription,
      }));

      setProductPromotionList(formattedData);
    } catch (error) {
      console.error("Error fetching product promotion:", error);
      setProductPromotionList([]);
    }
  };

  // API Calls
  const fetchVatFlag = async () => {
    try {
      const params = {
        company: authUser.company !== "#" ? authUser.company : "",
        language: languageSelected?.id || 1,
        salesmanCode: authUser.salesman !== "#" ? authUser.salesman : "",
        user: authUser.salesman !== "#" ? authUser.salesman : "",
        type: "VatFlag"
      };

      const url = `${process.env.REACT_APP_API_URL}lookup`;
      const config = {
        params,
        headers: {
          Authorization: `Bearer ${localStorage.getItem('x-access-token')}`,
        },
      };

      const response = await axios.get(url, config);
      const data = response.data.data || response.data;

      // แปลง format เป็น value, label
      const formattedData = data.map((item) => ({
        value: item.LookupCode,
        label: item.LookupDescription,
      }));

      setVatTypeList(formattedData);
    } catch (error) {
      console.error("Error fetching vat type:", error);
      setVatTypeList([]);
    }
  };

  // เมื่อ component mount ให้ fetch ข้อมูลครั้งแรก
  useEffect(() => {
    if (authUser && authUser.company) {
      fetchProductItemGroup();
      fetchProductGroup();
      fetchProductLine();
      fetchProductType();
      fetchMarketingEvent();
      fetchProductPromotion();
      fetchVatFlag();
    }
  }, [authUser, languageSelected]);

  // เมื่อ filter เปลี่ยนให้ fetch ข้อมูล filter อื่นๆ ใหม่ (เพราะมีผลต่อกัน)
  useEffect(() => {
    if (authUser && authUser.company) {
      fetchProductItemGroup();
      fetchProductGroup();
      fetchProductLine();
      fetchProductType();
      fetchMarketingEvent();
      fetchProductPromotion();
    }
  }, [
    selectedProductItemGroup,
    selectedProductGroup,
    selectedProductLine,
    selectedProductType,
    selectedMarketingEvent,
    selectedProductPromotion,
  ]);

  // ส่งค่า filter ไปยัง parent component (ProductList) เมื่อมีการเปลี่ยนแปลง
  useEffect(() => {
    if (onFilterChange) {
      const filterData = {
        selectedTab,
        itemGroup: selectedProductItemGroup?.value || "",
        productGroup: selectedProductGroup?.value || "",
        productLine: selectedProductLine?.value || "",
        productType: selectedProductType?.value || "",
        mktEventCode: selectedMarketingEvent?.value || "",
        productSetCode: selectedProductPromotion?.value || "",
        vatType: selectedVatType?.value || "",
      };
      onFilterChange(filterData);
    }
  }, [
    selectedTab,
    selectedProductItemGroup,
    selectedProductGroup,
    selectedProductLine,
    selectedProductType,
    selectedMarketingEvent,
    selectedProductPromotion,
    selectedVatType,
  ]);

  // Handle change for SelectInput
  const handleProductItemGroupChange = (value) => {
    setSelectedProductItemGroup(value);
    // Reset ตัวอื่นๆ ที่ขึ้นต่อกัน
    setSelectedProductGroup(null);
    setSelectedProductLine(null);
    setSelectedProductType(null);
  };

  const handleProductGroupChange = (value) => {
    setSelectedProductGroup(value);
    setSelectedProductLine(null);
    setSelectedProductType(null);
  };

  const handleProductLineChange = (value) => {
    setSelectedProductLine(value);
    setSelectedProductType(null);
  };

  const handleProductTypeChange = (value) => {
    setSelectedProductType(value);
  };

  const handleMarketingEventChange = (value) => {
    setSelectedMarketingEvent(value);
  };

  const handleProductPromotionChange = (value) => {
    setSelectedProductPromotion(value);
  };

  const handleVatTypeChange = (value) => {
    setSelectedVatType(value);
  };


  // สไตล์ปุ่ม
  const getButtonStyle = (tab) => ({
    border: "1px solid",
    borderColor: selectedTab === tab ? "orange" : "#9e9e9e",
    color: selectedTab === tab ? "orange" : "#9e9e9e",
    backgroundColor: "transparent",
    textTransform: "none",
    fontWeight: 500,
    width: "100%"
  });

  return (
    <Box>
      <div style={{ maxWidth: 800 }}>
        <Box
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          style={{ width: "100%" }}
        >
          {/* ข้อความชิดซ้าย */}
          <Typography variant="h6">{translator(translate.ISA_SearchProduct, "ค้นหาสินค้า")}</Typography>

          {/* ไอคอนชิดขวา */}
          <IconButton onClick={() => setOpen(!open)}>
            {open ? <ExpandLess /> : <ExpandMore />}
          </IconButton>
        </Box>

        {/* Collapse Form */}
        <Collapse isOpen={open}>
          {/* Tabs เลือกสินค้าทั้งหมด/ใช้งานบ่อย */}
          <Grid container spacing={2} style={{ marginTop: 8 }}>
            <Grid item xs={6}>
              <Button
                style={getButtonStyle("all")}
                variant="outlined"
                onClick={() => setSelectedTab("all")}
                disabled={isDisabled}
              >
                {translator(translate.ISA_AllProducts, "สินค้าทั้งหมด")}
              </Button>
            </Grid>
            {docType !== "DOC_SRT" && docType !== "DOC_SREC"  && docType !== "DOC_SPO" && docType !== "DOC_SPR" &&
              <Grid item xs={6}>
                <Button
                  style={getButtonStyle("frequent")}
                  variant="outlined"
                  onClick={() => setSelectedTab("frequent")}
                  disabled={isDisabled}
                >
                  {translator(translate.ISA_ButtonProductFav, "สินค้าใช้งานบ่อย")}
                </Button>
              </Grid>
            }
          </Grid>

          <Grid container spacing={2} style={{ marginTop: 16 }}>
            <Grid item xs={6} sx={{ mt: 1, mb: 1 }} >
              <SelectInput
                label={translator(translate.ISA_ItemCategory, "หมวดสินค้า")}
                value={selectedProductItemGroup}
                onChange={handleProductItemGroupChange}
                options={productItemGroupList}
                placeholder={translator(translate.ISA_All, "ทั้งหมด")}
                isClearable
                isSearchable
                isDisabled={isDisabled} />
            </Grid>
            <Grid item xs={6} sx={{ mt: 1, mb: 1 }} >
              <SelectInput
                label={translator(translate.ISA_ProductGroup, "กลุ่มสินค้า")}
                value={selectedProductGroup}
                onChange={handleProductGroupChange}
                options={productGroupList}
                placeholder={translator(translate.ISA_All, "ทั้งหมด")}
                isClearable
                isSearchable
                isDisabled={isDisabled} />
            </Grid>

            <Grid item xs={6} sx={{ mt: 1, mb: 1 }} >
              <SelectInput
                label={translator(translate.ISA_ProductLine, "Line สินค้า")}
                value={selectedProductLine}
                onChange={handleProductLineChange}
                options={productLineList}
                placeholder={translator(translate.ISA_All, "ทั้งหมด")}
                isClearable
                isSearchable
                isDisabled={isDisabled} />
            </Grid>
            <Grid item xs={6} sx={{ mt: 1, mb: 1 }} >
              <SelectInput
                label={translator(translate.ISA_ProductType, "ประเภทสินค้า")}
                value={selectedProductType}
                onChange={handleProductTypeChange}
                options={productTypeList}
                placeholder={translator(translate.ISA_All, "ทั้งหมด")}
                isClearable
                isSearchable
                isDisabled={isDisabled} />
            </Grid>

            {docType !== 'DOC_SRT' && docType !== 'DOC_SPO' && docType !== 'DOC_SREC'  && docType !== 'DOC_SPR' && (
              <>
                <Grid item xs={6}>
                  <SelectInput
                    label={translator(translate.ISA_MKTEvents, "กิจกรรมการตลาด")}
                    value={selectedMarketingEvent}
                    onChange={handleMarketingEventChange}
                    options={marketingEventList}
                    placeholder={translator(translate.ISA_All, "ทั้งหมด")}
                    isClearable
                    isSearchable
                    isDisabled={isDisabled} />
                </Grid>
                <Grid item xs={6}>
                  <SelectInput
                    label={translator(translate.ISA_ProductEvent, "สินค้าร่วมรายการ")}
                    value={selectedProductPromotion}
                    onChange={handleProductPromotionChange}
                    options={productPromotionList}
                    placeholder={translator(translate.ISA_All, "ทั้งหมด")}
                    isClearable
                    isSearchable
                    isDisabled={isDisabled} />
                </Grid>
              </>
            )}

            <Grid item xs={6}>
              <SelectInput
                label={translator(translate.ISA_VatType, "ประเภทสินค้า VAT")}
                value={selectedVatType}
                onChange={handleVatTypeChange}
                options={vatTypeList}
                placeholder={translator(translate.ISA_All, "ทั้งหมด")}
                isClearable
                isSearchable
                isDisabled={isDisabled} />
            </Grid>
          </Grid>
        </Collapse>

        <div style={{ marginTop: 16 }}>&nbsp;</div>
      </div>
    </Box>
  );
};

export default ProductSelectorFilter;